// extracted by mini-css-extract-plugin
export default {"container":"Monthly_container__ZcH7P","mode":"Monthly_mode__561pk","flipping":"Monthly_flipping__Ncp4w","link":"Monthly_link__hbtFu"};